import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { map } from 'rxjs';
import { EaGridkyService } from '../ea-gridky.service';

@Component({
    selector: 'ea-gridky-performances',
    templateUrl: './ea-gridky-performances.component.html',
    styleUrls: ['./ea-gridky-performances.component.scss'],
    standalone: false
})
export class EaGridkyPerformancesComponent implements OnInit {
  constructor(
    private gridkyService: EaGridkyService,
    private breakpointObserver: BreakpointObserver,
  ) {}

  isSmallScreen = false;

  ngOnInit() {
    this.breakpointObserver
      .observe('(max-width: 768px)')
      .subscribe(breakpoint => (this.isSmallScreen = breakpoint.matches));
  }

  get product() {
    return this.gridkyService.product || undefined;
  }
}
